// Mock data for Agile Connexion INC
// NOTE: This is placeholder/fictional content for the frontend-only build.

export const COMPANY = {
  name: "Agile Connexion",
  legalName: "Agile Connexion INC",
  tagline: "GOUVERNANCE TI | AGILITÉ | PERFORMANCE",
  domain: "agile-connexion.com",
  address: "310 - 1200 Boulevard Pie-XI Sud, Québec, QC G3K 0W2, Canada",
  phone: "+1 418 955 7869",
  phoneHref: "+14189557869",
  email: "support@agile-connexion.com",
  social: {
    linkedin: "https://www.linkedin.com",
    facebook: "https://www.facebook.com"
  },
  mapEmbed:
    "https://www.google.com/maps?q=1200+Boulevard+Pie-XI+Sud,+Qu%C3%A9bec,+QC+G3K+0W2&output=embed"
};

export const HERO_SLIDES = [
  {
    id: "slide-boardroom",
    image:
      "https://images.unsplash.com/photo-1777264935754-aa53096c2d68?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBib2FyZHJvb218ZW58MHx8fHwxNzgyNTM0Nzk0fDA&ixlib=rb-4.1.0&q=85",
    title: "GOUVERNANCE TI | AGILITÉ | PERFORMANCE"
  },
  {
    id: "slide-office",
    image:
      "https://images.pexels.com/photos/13219418/pexels-photo-13219418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    title: "GOUVERNANCE TI | AGILITÉ | PERFORMANCE"
  },
  {
    id: "slide-strategy",
    image:
      "https://images.pexels.com/photos/32168739/pexels-photo-32168739.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
    title: "GOUVERNANCE TI | AGILITÉ | PERFORMANCE"
  }
];

export const VALUE_PROP = {
  intro:
    "Agile Connexion INC est un cabinet de conseil spécialisé en gouvernance des technologies de l'information (TI) et en transformation agile.",
  body:
    "Nous accompagnons les organisations dans l'optimisation de leurs structures de gestion, l'alignement stratégique de leurs TI et l'adoption de cadres de travail agiles pour accroître leur efficacité opérationnelle."
};

export const SERVICES = [
  {
    id: "gouvernance-ti",
    title: "Accompagnement en Gouvernance TI",
    short: "Gouvernance TI",
    image:
      "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt:
      "Mise en place de cadres de gouvernance robustes pour assurer l'alignement des technologies de l'information avec les objectifs stratégiques de l'organisation.",
    details: [
      "Élaboration et modernisation de cadres de gouvernance TI (COBIT, ISO/IEC 38500).",
      "Définition des rôles, responsabilités et instances de décision.",
      "Alignement des investissements technologiques sur la stratégie d'affaires.",
      "Gestion des risques TI et conformité réglementaire."
    ]
  },
  {
    id: "transformation-agile",
    title: "Transformation Agile et Lean",
    short: "Transformation Agile",
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt:
      "Accompagnement des équipes dans l'adoption de méthodologies agiles (Scrum, Kanban) pour accroître l'efficacité opérationnelle et la réactivité organisationnelle.",
    details: [
      "Diagnostic de maturité agile et feuille de route de transformation.",
      "Mise en place de cadres Scrum, Kanban et SAFe à l'échelle.",
      "Optimisation des flux de valeur selon les principes Lean.",
      "Accompagnement du changement et coaching des équipes."
    ]
  },
  {
    id: "gestion-projet-pmo",
    title: "Gestion de Projet et PMO",
    short: "Gestion de Projet & PMO",
    image:
      "https://images.unsplash.com/photo-1531403009284-440f080d1e12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt:
      "Conseil en gestion de projet et structuration de bureaux de gestion de projets (PMO) pour améliorer le suivi, la transparence et la livraison des initiatives technologiques.",
    details: [
      "Création et structuration de bureaux de projets (PMO).",
      "Mise en place de tableaux de bord et indicateurs de performance.",
      "Gouvernance de portefeuille et priorisation des initiatives.",
      "Méthodologies hybrides (prédictif / agile) adaptées au contexte."
    ]
  },
  {
    id: "audit-diagnostic",
    title: "Audit et Diagnostic Organisationnel",
    short: "Audit & Diagnostic",
    image:
      "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt:
      "Évaluation de la maturité technologique et agile actuelle de votre entreprise, suivie de recommandations concrètes pour optimiser les processus de gouvernance.",
    details: [
      "Évaluation de la maturité TI et agile de l'organisation.",
      "Analyse des processus, des structures et des outils en place.",
      "Recommandations concrètes et plan d'action priorisé.",
      "Suivi de la mise en œuvre et mesure des résultats."
    ]
  },
  {
    id: "formation-coaching",
    title: "Formation et Coaching Agile",
    short: "Formation & Coaching",
    image:
      "https://images.pexels.com/photos/8761330/pexels-photo-8761330.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    excerpt:
      "Séances de formation personnalisées pour les équipes et les gestionnaires sur les meilleures pratiques de gouvernance TI et les cadres de travail agiles.",
    details: [
      "Formations sur mesure en gouvernance TI et agilité.",
      "Coaching individuel et collectif des gestionnaires et équipes.",
      "Ateliers pratiques et simulations.",
      "Accompagnement post-formation pour ancrer les apprentissages."
    ]
  }
];

export const FORMATIONS = [
  {
    id: "groupe",
    title: "DE GROUPE",
    image:
      "https://images.unsplash.com/photo-1776039325185-8fd3d46af4e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt:
      "En entreprise, dans nos locaux ou en ligne pour les groupes (conseil d'administration, équipe de direction, équipe de gestionnaires, etc.), nous proposons une programmation complète de formations en gouvernance TI et agilité."
  },
  {
    id: "individuelles",
    title: "INDIVIDUELLES",
    image:
      "https://images.unsplash.com/photo-1513258496099-48168024aec0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    excerpt:
      "Individuellement via le Centre de formation en ligne d'Agile Connexion, nous proposons une programmation complète de formations en gouvernance TI, agilité et gestion de projet."
  }
];

export const FORMATION_CATALOG = [
  {
    id: "f1",
    title: "Fondements de la gouvernance TI",
    level: "Débutant",
    duration: "2 jours",
    mode: "Présentiel / En ligne",
    description:
      "Comprendre les principes, cadres et bonnes pratiques de la gouvernance des technologies de l'information."
  },
  {
    id: "f2",
    title: "Scrum Master en pratique",
    level: "Intermédiaire",
    duration: "2 jours",
    mode: "Présentiel / En ligne",
    description:
      "Maîtriser le rôle de Scrum Master et faciliter une équipe agile performante au quotidien."
  },
  {
    id: "f3",
    title: "Product Owner et gestion de la valeur",
    level: "Intermédiaire",
    duration: "2 jours",
    mode: "Présentiel / En ligne",
    description:
      "Prioriser, structurer le backlog et maximiser la valeur livrée aux parties prenantes."
  },
  {
    id: "f4",
    title: "Mettre en place un PMO efficace",
    level: "Avancé",
    duration: "1 jour",
    mode: "Présentiel",
    description:
      "Concevoir et déployer un bureau de gestion de projets aligné sur la stratégie de l'organisation."
  },
  {
    id: "f5",
    title: "Agilité à l'échelle (SAFe / LeSS)",
    level: "Avancé",
    duration: "3 jours",
    mode: "Présentiel / En ligne",
    description:
      "Coordonner plusieurs équipes agiles et déployer l'agilité à l'échelle de l'entreprise."
  },
  {
    id: "f6",
    title: "Leadership et conduite du changement",
    level: "Intermédiaire",
    duration: "1 jour",
    mode: "En ligne",
    description:
      "Accompagner les équipes et les gestionnaires à travers les transformations organisationnelles."
  }
];

export const WHY_CHOOSE = {
  image:
    "https://images.unsplash.com/photo-1519389950473-47ba0277781c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  points: [
    {
      title: "Expertise reconnue",
      text: "Une équipe de conseillers chevronnés en gouvernance TI, agilité et gestion de projet."
    },
    {
      title: "Approche sur mesure",
      text: "Des solutions adaptées à votre contexte, votre culture et vos objectifs d'affaires."
    },
    {
      title: "Résultats concrets",
      text: "Un accompagnement orienté vers la performance et la création de valeur durable."
    },
    {
      title: "Transfert de savoir",
      text: "Nous rendons vos équipes autonomes grâce à la formation et au coaching."
    }
  ]
};

export const TEAM = [
  {
    id: "t1",
    name: "Doua Firmin GON",
    role: "Conseiller principal en gouvernance TI et cadre méthodologique",
    initials: "DG",
    linkedin: "https://www.linkedin.com/in/doua-firmin-gon-876508208/",
    bio: "Fondateur d'Agile Connexion, il accompagne les organisations dans la mise en place de cadres de gouvernance TI robustes et de cadres méthodologiques adaptés à leurs enjeux."
  },
  {
    id: "t2",
    name: "Marcos Cardoso",
    role: "Conseiller senior cadre méthodologique",
    initials: "MC",
    linkedin: "https://www.linkedin.com/in/marcosjgc/",
    bio: "Conseiller senior en cadre méthodologique, il appuie les organisations dans la structuration et l'amélioration de leurs pratiques de gestion."
  },
  {
    id: "t3",
    name: "Profil à venir",
    role: "",
    initials: "+",
    linkedin: "",
    bio: "Ce membre de l'équipe sera présenté prochainement.",
    placeholder: true
  },
  {
    id: "t4",
    name: "Profil à venir",
    role: "",
    initials: "+",
    linkedin: "",
    bio: "Ce membre de l'équipe sera présenté prochainement.",
    placeholder: true
  }
];

export const NEWS = [
  {
    id: "aligner-ti-strategie",
    title: "Aligner vos TI sur votre stratégie d'affaires : par où commencer ?",
    category: "Gouvernance TI",
    date: "12 juin 2025",
    author: "Doua Firmin GON",
    readTime: "6 min",
    image:
      "https://images.unsplash.com/photo-1531403009284-440f080d1e12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    excerpt:
      "Trop d'organisations gèrent leurs technologies en silo, déconnectées de leurs objectifs d'affaires. Voici une démarche concrète pour rétablir l'alignement.",
    intro:
      "Dans bon nombre d'organisations, les technologies de l'information avancent à un rythme, et la stratégie d'affaires à un autre. Résultat : des investissements coûteux qui ne soutiennent pas vraiment les priorités de la direction, et un sentiment diffus que « les TI coûtent cher sans qu'on sache ce qu'elles rapportent ». L'alignement stratégique des TI vise précisément à corriger ce décalage. Mais par où commencer ?",
    sections: [
      {
        heading: "1. Clarifier la stratégie d'affaires avant de parler technologie",
        paragraphs: [
          "On ne peut pas aligner les TI sur une stratégie qui n'est pas explicite. La première étape consiste donc à formaliser clairement les objectifs d'affaires : croissance, efficacité opérationnelle, expérience client, conformité réglementaire, etc.",
          "Chaque objectif doit être traduit en résultats mesurables. C'est cette traduction qui permettra, plus tard, de juger si un projet technologique contribue réellement à la stratégie ou non."
        ]
      },
      {
        heading: "2. Cartographier la contribution des TI",
        paragraphs: [
          "Une fois les objectifs clairs, il s'agit de relier chaque grande capacité technologique à un objectif d'affaires. Cette cartographie révèle souvent des surprises : des systèmes critiques sous-financés, et des initiatives bien financées qui ne soutiennent aucune priorité réelle."
        ],
        list: [
          "Quels objectifs d'affaires chaque système soutient-il ?",
          "Quels processus dépendent de quelles applications ?",
          "Où se concentrent les dépenses, et pour quel bénéfice ?"
        ]
      },
      {
        heading: "3. Mettre en place une gouvernance des décisions",
        paragraphs: [
          "L'alignement n'est pas un projet ponctuel, c'est un mode de fonctionnement. Il faut définir qui décide quoi : quelles instances priorisent les investissements, arbitrent les conflits et valident la valeur attendue de chaque initiative.",
          "Un comité de gouvernance TI, réunissant direction d'affaires et direction technologique, est généralement le mécanisme le plus efficace pour maintenir cette discipline dans la durée."
        ]
      },
      {
        heading: "4. Mesurer, ajuster, recommencer",
        paragraphs: [
          "L'alignement se vérifie avec des indicateurs : taux de projets livrés contribuant à un objectif stratégique, satisfaction des parties prenantes, retour sur investissement des initiatives majeures. Ces mesures alimentent un cycle d'amélioration continue."
        ]
      }
    ],
    conclusion:
      "Aligner les TI sur la stratégie d'affaires n'exige pas une refonte spectaculaire : cela commence par de la clarté, de la transparence et une gouvernance disciplinée. Chez Agile Connexion, nous accompagnons les organisations pas à pas dans cette démarche, du diagnostic initial jusqu'à la mise en place des instances de décision.",
    comingSoon: false
  },
  {
    id: "cobit-iso-38500",
    title: "COBIT, ISO/IEC 38500 : quel cadre de gouvernance choisir pour votre organisation ?",
    category: "Gouvernance TI",
    date: "28 mai 2025",
    author: "Doua Firmin GON",
    readTime: "7 min",
    image:
      "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    excerpt:
      "COBIT et ISO/IEC 38500 sont souvent cités comme références en gouvernance TI. Mais ils ne répondent pas aux mêmes besoins. Comment choisir ?",
    intro:
      "Lorsqu'une organisation décide de structurer sa gouvernance des TI, deux références reviennent presque toujours : COBIT et la norme ISO/IEC 38500. Les deux sont solides et reconnues, mais elles n'ont ni la même portée ni le même niveau de détail. Les confondre — ou choisir l'une par défaut — mène souvent à un cadre mal adapté.",
    sections: [
      {
        heading: "ISO/IEC 38500 : une boussole pour la direction",
        paragraphs: [
          "ISO/IEC 38500 est une norme de haut niveau destinée aux dirigeants et aux conseils d'administration. Elle énonce des principes de gouvernance — responsabilité, stratégie, acquisition, performance, conformité et comportement humain — sans entrer dans le détail opérationnel.",
          "Son intérêt : donner un langage commun et des principes clairs à la haute direction. Sa limite : elle ne dit pas « comment » faire au quotidien."
        ]
      },
      {
        heading: "COBIT : un cadre détaillé pour la mise en œuvre",
        paragraphs: [
          "COBIT est un cadre beaucoup plus complet et opérationnel. Il propose des objectifs de gouvernance et de gestion, des processus, des indicateurs et des modèles de maturité. Il permet de passer des principes à la pratique concrète.",
          "Son intérêt : structurer finement les processus TI et mesurer leur maturité. Sa contrepartie : il demande plus d'effort d'appropriation et doit être adapté au contexte, jamais appliqué intégralement « tel quel »."
        ]
      },
      {
        heading: "Les deux sont complémentaires, pas concurrents",
        paragraphs: [
          "En pratique, beaucoup d'organisations utilisent ISO/IEC 38500 pour cadrer la gouvernance au niveau de la direction, et COBIT pour structurer la mise en œuvre opérationnelle. Le choix dépend surtout de votre point de départ et de votre maturité."
        ],
        list: [
          "Vous débutez et cherchez à mobiliser la direction ? Commencez par les principes d'ISO/IEC 38500.",
          "Vous devez structurer des processus et mesurer la maturité ? Appuyez-vous sur COBIT.",
          "Vous êtes dans un secteur très réglementé ? Combinez les deux et reliez-les à vos obligations de conformité."
        ]
      }
    ],
    conclusion:
      "Le « bon » cadre n'est pas le plus complet, mais celui que votre organisation peut réellement adopter et faire vivre. Notre rôle chez Agile Connexion est de vous aider à choisir, adapter et déployer le cadre qui correspond à votre maturité — sans bureaucratie inutile.",
    comingSoon: false
  },
  {
    id: "transformation-agile-au-dela-ceremonies",
    title: "Réussir sa transformation agile : au-delà des cérémonies Scrum",
    category: "Agilité",
    date: "14 mai 2025",
    author: "Marcos Cardoso",
    readTime: "6 min",
    image:
      "https://images.pexels.com/photos/8276211/pexels-photo-8276211.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=800&w=1200",
    excerpt:
      "Adopter les rituels Scrum ne suffit pas à devenir agile. La vraie transformation se joue dans la culture, le leadership et la création de valeur.",
    intro:
      "De nombreuses organisations « font du Scrum » : elles tiennent des mêlées quotidiennes, des revues et des rétrospectives. Pourtant, beaucoup ne ressentent jamais les bénéfices promis par l'agilité. La raison est simple : la transformation agile ne se résume pas à un ensemble de cérémonies. C'est avant tout un changement de culture et de posture.",
    sections: [
      {
        heading: "Le piège de l'agilité de façade",
        paragraphs: [
          "Reproduire mécaniquement les rituels sans en comprendre l'intention donne ce qu'on appelle une agilité « de façade ». Les équipes cochent les cases mais conservent les comportements anciens : décisions descendantes, planification rigide, peur de l'erreur.",
          "Les cérémonies ne sont que des outils au service de principes : livrer de la valeur fréquemment, inspecter et adapter, collaborer étroitement. Sans ces principes, les rituels deviennent vite des réunions creuses."
        ]
      },
      {
        heading: "Trois leviers souvent négligés",
        paragraphs: [
          "Une transformation agile durable repose sur des fondations bien plus profondes que le cadre Scrum lui-même."
        ],
        list: [
          "Le leadership : les gestionnaires doivent passer du contrôle à la facilitation, et accepter de déléguer la décision aux équipes.",
          "La sécurité psychologique : sans droit à l'erreur, pas d'expérimentation ni d'amélioration continue.",
          "L'orientation valeur : mesurer le succès par la valeur livrée au client, pas par le nombre de tâches terminées."
        ]
      },
      {
        heading: "Commencer petit, mais commencer juste",
        paragraphs: [
          "Inutile de transformer toute l'organisation d'un coup. Mieux vaut démarrer avec une ou deux équipes pilotes, leur donner les moyens de réussir, puis diffuser les apprentissages. L'effet d'entraînement est souvent plus puissant qu'un grand programme imposé d'en haut."
        ]
      }
    ],
    conclusion:
      "L'agilité n'est pas une recette, c'est une dynamique. Réussir sa transformation, c'est faire évoluer la culture, le leadership et la manière de créer de la valeur. Agile Connexion accompagne les équipes et les directions pour ancrer durablement ces changements, bien au-delà des cérémonies.",
    comingSoon: false
  },
  {
    id: "pmo-moderne-creation-valeur",
    title: "Le PMO moderne : du contrôle à la création de valeur",
    category: "Gestion de projet",
    date: "2 mai 2025",
    author: "Marcos Cardoso",
    readTime: "5 min",
    image:
      "https://images.unsplash.com/photo-1542626991-cbc4e32524cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    excerpt:
      "Longtemps perçu comme un organe de contrôle, le bureau de projets se réinvente en partenaire stratégique de la direction. Comment opérer ce virage ?",
    intro:
      "Le bureau de gestion de projets (PMO) a longtemps été associé au reporting, aux gabarits et au respect des processus. Utile, mais parfois vécu comme un frein. Le PMO moderne adopte une posture radicalement différente : il devient un catalyseur de valeur, au service de la stratégie de l'organisation.",
    sections: [
      {
        heading: "Du PMO « gendarme » au PMO « partenaire »",
        paragraphs: [
          "Le PMO traditionnel veille au respect des règles et collecte de l'information. Le PMO moderne, lui, aide les équipes à livrer, lève les obstacles et éclaire les décisions de la direction grâce à une vision consolidée du portefeuille."
        ]
      },
      {
        heading: "Trois rôles clés du PMO moderne",
        paragraphs: [
          "Pour créer de la valeur, le PMO doit assumer des responsabilités qui dépassent le simple suivi des projets."
        ],
        list: [
          "Prioriser : aider la direction à choisir les bonnes initiatives, pas seulement à suivre celles en cours.",
          "Faciliter : fournir méthodes, outils et coaching pour accélérer la livraison.",
          "Éclairer : transformer les données de projets en informations utiles à la décision."
        ]
      },
      {
        heading: "S'adapter à la réalité agile et hybride",
        paragraphs: [
          "Les organisations mènent aujourd'hui des projets prédictifs, agiles et hybrides en parallèle. Le PMO moderne ne fige pas une seule méthode : il propose un cadre souple, adapté à la nature de chaque initiative, et privilégie des indicateurs de valeur plutôt que de simples mesures d'avancement."
        ]
      }
    ],
    conclusion:
      "Réinventer son PMO, c'est passer du contrôle à la contribution. Bien positionné, le bureau de projets devient l'un des meilleurs alliés de la direction. Agile Connexion accompagne les organisations dans la conception et le déploiement de PMO résolument tournés vers la création de valeur.",
    comingSoon: false
  },
  {
    id: "gouvernance-ti-gestion-risques",
    title: "Gouvernance TI et gestion des risques : les angles morts à surveiller",
    category: "Gouvernance TI",
    date: "18 avril 2025",
    author: "Doua Firmin GON",
    readTime: "6 min",
    image:
      "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    excerpt:
      "Cybersécurité, dépendances fournisseurs, dette technique : un tour d'horizon des risques TI trop souvent sous-estimés par les directions.",
    intro:
      "Une bonne gouvernance des TI ne se limite pas à aligner technologies et stratégie : elle doit aussi anticiper ce qui peut mal tourner. Or, dans beaucoup d'organisations, la gestion des risques TI reste superficielle, concentrée sur quelques menaces visibles. Les véritables dangers se cachent souvent dans les angles morts.",
    sections: [
      {
        heading: "La cybersécurité ne se résume pas à la technique",
        paragraphs: [
          "On pense souvent la cybersécurité en termes d'outils : pare-feu, antivirus, chiffrement. Mais les incidents les plus coûteux proviennent fréquemment de causes humaines et organisationnelles : hameçonnage, mauvaise gestion des accès, absence de plan de réponse aux incidents.",
          "La gouvernance doit donc traiter la sécurité comme un enjeu transversal, impliquant la direction, les processus et la culture — pas seulement le département TI."
        ]
      },
      {
        heading: "Les dépendances fournisseurs : un risque concentré",
        paragraphs: [
          "L'infonuagique et les services tiers ont apporté agilité et économies, mais aussi une dépendance croissante. Que se passe-t-il si un fournisseur critique subit une panne prolongée, augmente brutalement ses tarifs ou cesse ses activités ?"
        ],
        list: [
          "Identifiez vos fournisseurs critiques et le niveau de dépendance associé.",
          "Vérifiez les clauses de réversibilité et de continuité de service des contrats.",
          "Évaluez les scénarios de sortie ou de bascule vers une solution alternative."
        ]
      },
      {
        heading: "La dette technique, ce risque silencieux",
        paragraphs: [
          "La dette technique — ces raccourcis et systèmes vieillissants accumulés au fil du temps — n'apparaît dans aucun tableau de bord financier. Pourtant, elle ralentit les projets, fragilise la sécurité et fait grimper les coûts de maintenance.",
          "Une gouvernance mature rend cette dette visible, la mesure et planifie sa réduction au même titre que les nouveaux investissements."
        ]
      },
      {
        heading: "Gouverner le risque, c'est décider en connaissance de cause",
        paragraphs: [
          "L'objectif n'est pas d'éliminer tous les risques — c'est impossible — mais de les rendre visibles, de les prioriser et de décider lesquels accepter, réduire ou transférer. Un registre des risques TI, revu régulièrement par une instance de gouvernance, est l'outil de base de cette discipline."
        ]
      }
    ],
    conclusion:
      "Les angles morts du risque TI coûtent cher précisément parce qu'ils restent invisibles jusqu'à l'incident. Chez Agile Connexion, nous aidons les organisations à éclairer ces zones d'ombre et à intégrer la gestion des risques au cœur de leur gouvernance.",
    comingSoon: false
  },
  {
    id: "scrum-kanban-safe-choisir",
    title: "Scrum, Kanban, SAFe : comment choisir le bon cadre agile ?",
    category: "Agilité",
    date: "4 avril 2025",
    author: "Marcos Cardoso",
    readTime: "6 min",
    image:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    excerpt:
      "Chaque cadre agile répond à un contexte précis. Guide pratique pour choisir celui qui convient à vos équipes et à votre échelle.",
    intro:
      "Scrum, Kanban, SAFe… Les cadres agiles se multiplient et la tentation est grande d'adopter le plus populaire ou le plus impressionnant sur le papier. Pourtant, le meilleur cadre est simplement celui qui correspond à votre contexte. Voici comment s'y retrouver.",
    sections: [
      {
        heading: "Scrum : pour livrer par itérations sur un périmètre évolutif",
        paragraphs: [
          "Scrum organise le travail en itérations courtes (sprints) avec des rôles, des événements et des artefacts bien définis. Il convient particulièrement aux équipes qui développent un produit dont les priorités évoluent et qui veulent livrer de la valeur de façon régulière et prévisible.",
          "Il fonctionne mieux avec une équipe stable, dédiée et pluridisciplinaire, et un Product Owner réellement disponible pour prioriser."
        ]
      },
      {
        heading: "Kanban : pour fluidifier un flux de travail continu",
        paragraphs: [
          "Kanban ne prescrit ni rôles ni itérations : il visualise le flux de travail, limite le travail en cours et cherche à réduire les délais. C'est un excellent choix pour les équipes dont la demande est continue et imprévisible — support, exploitation, maintenance, demandes entrantes variées.",
          "Son grand avantage : il s'introduit sans bouleverser l'organisation existante, en partant des processus actuels pour les améliorer progressivement."
        ]
      },
      {
        heading: "SAFe : pour coordonner l'agilité à grande échelle",
        paragraphs: [
          "Lorsque plusieurs dizaines d'équipes doivent collaborer sur un même produit ou une même chaîne de valeur, la coordination devient le vrai défi. Des cadres d'agilité à l'échelle comme SAFe apportent une structure pour aligner ces équipes, planifier ensemble et gérer les dépendances.",
          "Attention toutefois : ces cadres sont lourds. Les déployer dans une petite structure crée plus de bureaucratie que de valeur."
        ]
      },
      {
        heading: "Quelques repères pour choisir",
        paragraphs: [
          "Plutôt que de chercher « le » cadre parfait, posez-vous les bonnes questions sur votre contexte."
        ],
        list: [
          "Votre travail est-il itératif (produit) ou continu (flux de demandes) ?",
          "Combien d'équipes doivent se coordonner ?",
          "Quel est le niveau de maturité agile actuel de vos équipes ?",
          "Pouvez-vous dédier des équipes stables, ou les ressources sont-elles partagées ?"
        ]
      }
    ],
    conclusion:
      "Il est tout à fait possible — et souvent souhaitable — de combiner ces approches : Scrum avec des pratiques Kanban, par exemple. L'essentiel est de partir de votre réalité, pas d'un modèle théorique. Agile Connexion vous aide à choisir, adapter et faire évoluer le cadre le mieux adapté à vos équipes.",
    comingSoon: false
  },
  {
    id: "mesurer-maturite-agile",
    title: "Mesurer la maturité agile de votre organisation : méthode en 5 étapes",
    category: "Diagnostic",
    date: "20 mars 2025",
    author: "Marcos Cardoso",
    readTime: "5 min",
    image:
      "https://images.unsplash.com/photo-1517048676732-d65bc937f952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    excerpt:
      "Un diagnostic structuré est la première étape d'une transformation réussie. Découvrez notre méthode d'évaluation en cinq étapes.",
    intro:
      "« Sommes-nous vraiment agiles ? » La question revient souvent, mais les réponses restent floues, fondées sur des impressions. Mesurer la maturité agile permet de remplacer ces intuitions par un état des lieux objectif, point de départ de toute amélioration. Voici notre méthode en cinq étapes.",
    sections: [
      {
        heading: "Étape 1 — Définir les dimensions à évaluer",
        paragraphs: [
          "La maturité agile ne se résume pas aux pratiques d'équipe. Nous évaluons plusieurs dimensions : pratiques et techniques, culture et état d'esprit, leadership, structure organisationnelle et orientation valeur. Cadrer ces dimensions au départ évite une vision partielle."
        ]
      },
      {
        heading: "Étape 2 — Recueillir des données objectives et perçues",
        paragraphs: [
          "Un bon diagnostic croise deux sources : des données factuelles (délais de livraison, fréquence des mises en production, taux de retouches) et des données perçues (entretiens, questionnaires auprès des équipes et des gestionnaires). L'écart entre les deux est souvent très révélateur."
        ]
      },
      {
        heading: "Étape 3 — Situer la maturité sur une échelle",
        paragraphs: [
          "Les résultats sont positionnés sur une échelle de maturité, par dimension. L'objectif n'est pas de donner une « note » culpabilisante, mais de visualiser clairement les forces et les zones de progression."
        ],
        list: [
          "Initial : pratiques ponctuelles, peu d'alignement.",
          "En développement : pratiques en place mais inégales.",
          "Établi : pratiques cohérentes et partagées.",
          "Optimisé : amélioration continue ancrée dans la culture."
        ]
      },
      {
        heading: "Étape 4 — Prioriser les leviers d'amélioration",
        paragraphs: [
          "Toutes les faiblesses ne se valent pas. Nous identifions les leviers qui auront le plus d'impact avec le moins d'effort, et nous les traduisons en actions concrètes et réalistes, plutôt qu'en un catalogue de bonnes intentions."
        ]
      },
      {
        heading: "Étape 5 — Réévaluer pour piloter le progrès",
        paragraphs: [
          "La maturité agile n'est pas un état fixe. En refaisant le diagnostic à intervalles réguliers (par exemple tous les 6 à 12 mois), l'organisation mesure ses progrès réels et ajuste sa trajectoire. La mesure devient alors un véritable outil de pilotage."
        ]
      }
    ],
    conclusion:
      "Mesurer la maturité agile, c'est se donner une base claire pour progresser de manière ciblée plutôt qu'au hasard. Agile Connexion réalise ces diagnostics et accompagne ensuite les organisations dans la mise en œuvre des améliorations prioritaires.",
    comingSoon: false
  }
];

